// extracted by css-extract-rspack-plugin
export default {"HeroSection":"HeroSection-module__HeroSection__gXfQJ","LogoTilesHeading":"HeroSection-module__LogoTilesHeading__QFugq"};